<template>
  <div class="d-flex justify-content-center">
    <card class="col-10">
      <div class="card-header text-center">
        <slot name="header">
          <h3 class="card-title">{{ $t('userAccountsSearch.title') }}</h3>
          <h5 class="description">{{ $t('userAccountsSearch.firstStepSearchByPublicIdDescription') }}</h5>
        </slot>
      </div>

      <div class="card-body">
        <base-alert v-if="error" type="danger" dismissible>
          <!-- TODO: add error translation -->
          {{ error }}
        </base-alert>
        <form v-on:submit.prevent="doSearchAccount()">
          <div class="row">
            <div class="col-12">
              <p>
                <base-radio inline name="byPublicId" class="ml-3" v-model="model.searchBy" disabled/>
                {{ $t('userAccountsSearch.firstStepSearchByPublicIdDescription') }}
              </p>
            </div>
            <div class="col">
              <base-input
                id="public_id"
                name="public_id"
                required
                :placeholder="$t('userAccountsSearch.form.publicIdPlaceholder')"
                v-model="model.public_id"
                addon-left-icon="tim-icons icon-tag"
                @focus="model.searchBy = 'byPublicId'"
                ref="input_byPublicId"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p v-if="$auth.can({account_additional_details: 'read'}, 'permissions')">
                <base-radio inline name="byIdentifier" class="ml-3" v-model="model.searchBy" disabled/>
                {{ $t('userAccountsSearch.firstStepSearchByIdentifierDescription') }}
              </p>
            </div>
            <div class="col" v-if="$auth.can({account_additional_details: 'read'}, 'permissions')">
              <base-input
                id="identifier"
                name="identifier"
                required
                :placeholder="$t('userAccountsSearch.form.identifierPlaceholder')"
                v-model="model.identifier"
                addon-left-icon="tim-icons icon-badge"
                @focus="model.searchBy = 'byIdentifier'"
                ref="input_byIdentifier"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p>
                <base-radio inline name="byEmail" class="ml-3" v-model="model.searchBy" disabled/>
                {{ $t('userAccountsSearch.firstStepSearchByEmailDescription') }}
              </p>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <base-input
                    id="email"
                    name="email"
                    required
                    :placeholder="$t('userAccountsSearch.form.emailPlaceholder')"
                    v-model="model.email"
                    v-validate="modelValidations.email"
                    addon-left-icon="tim-icons icon-email-85"
                    @focus="model.searchBy = 'byEmail'"
                    ref="input_byEmail"
                  >
                  </base-input>
                </div>
                <div class="col-md-4 col-sm-12">
                  <base-input
                    id="reference"
                    name="reference"
                    required
                    :placeholder="$t('userAccountsSearch.form.referenceKeyPlaceholder')"
                    v-model="model.reference_key"
                    addon-left-icon="tim-icons icon-key-25"
                    @focus="model.searchBy = 'byEmail'"
                  >
                  </base-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="!hideSearchBySerialNumber">
            <div class="col-12">
              <p>
                <base-radio inline name="bySerialNumber" class="ml-3" v-model="model.searchBy" disabled/>
                {{ $t('userAccountsSearch.firstStepSearchBySerialNumberDescription') }}
              </p>
            </div>
            <div class="col">
              <base-input
                id="serial_number"
                name="serial_number"
                required
                :placeholder="$t('userAccountsSearch.form.serialNumberPlaceholder')"
                v-model="model.serial_number"
                addon-left-icon="tim-icons icon-credit-card"
                @focus="model.searchBy = 'bySerialNumber'"
                ref="input_bySerialNumber"
              >
              </base-input>
            </div>
            <div class="col-1"  v-if="$auth.isAdmin()">
              <base-checkbox
                inline
                v-model="model.serial_number_emv"
              >{{ $t('userAccountsSearch.form.serialNumberEmvPlaceholder') }}</base-checkbox>
            </div>
          </div>

          <div class="row" v-if="$auth.isAdmin()">
            <div class="col-12">
              <p>
                <base-radio inline name="byAccountId" class="ml-3" v-model="model.searchBy" disabled/>
                {{ $t('userAccountsSearch.firstStepSearchByAccountIdDescription') }}
              </p>
            </div>
            <div class="col">
              <base-input
                id="accountId"
                name="accountId"
                required
                :placeholder="$t('userAccountsSearch.form.accountIdPlaceholder')"
                v-model="model.account_id"
                addon-left-icon="tim-icons icon-single-02"
                @focus="model.searchBy = 'byAccountId'"
                ref="input_byAccountId"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <base-button class="mt-3 float-right" native-type="submit" type="primary">
                {{ $t('userAccountsSearch.firstStepAction') }}
              </base-button>
            </div>
          </div>

        </form>
      </div>
    </card>
  </div>
</template>
<script>
import {BaseAlert, BaseRadio} from 'src/components';
import {mapActions, mapState} from "vuex";

export default {
  name: 'search-account',
  components: {
    BaseAlert,
    BaseRadio
  },
  props: {
    hideSearchBySerialNumber: {
      type: Boolean,
      description: "Will not show search by serial number."
    }
  },
  data() {
    return {
      model: {
        email: '',
        reference_key: '',
        public_id: '',
        serial_number: '',
        serial_number_emv: false,
        identifier: '',
        account_id: '',
        searchBy: 'byPublicId',
      },
      error: null,
      modelValidations: {
        firstName: {
          required: true,
          min: 5
        },
        lastName: {
          required: true,
          min: 5
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          numeric: true
        }
      }
    };
  },
  computed: {
    ...mapState({
      loading: state => state.account.loading,
      searchError: state => state.account.error,
      found: state => state.account,
    }),
  },
  methods: {
    ...mapActions(['SearchAccount']),
    async doSearchAccount() {
      this.error = null;
      await this.SearchAccount(this.model)
      if (this.searchError === null && this.found.data && this.found.data.id !== '') {
        // Forward to the result.
        switch (this.found.data.type) {
          case 'card':
            this.$router.push({name: 'account-season-tickets', params: {id: this.found.data.id}})
            break;
          default:
            this.$router.push({name: 'account-journeys', params: {id: this.found.data.id}})
        }
        return
      }
      this.error = this.searchError.body["error"];
      return false
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs["input_" + this.model.searchBy].$el.children[0].children[1].focus()
    })
  },
};
</script>
<style></style>
